import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export const projects = (state = initialState.projects, action) => {
  switch (action.type) {
    case types.LOAD_PROJECT_SUCCESS:
      return action.projects;

    case types.CREATE_PROJECT_SUCCESS:
      return [...state, { ...action.project }];

    case types.UPDATE_PROJECT_SUCCESS:
      return [
        ...state.filter((p) => p._id !== action.project._id),
        { ...action.project }
      ];

    case types.DELETE_PROJECT_SUCCESS:
      return [...state.filter((p) => p._id !== action.projectId)];

    default:
      return state;
  }
};

export const project = (state = initialState.project, action) => {
  switch (action.type) {
    case types.GET_PROJECT_SUCCESS:
      return action.project;
    case types.UPDATE_PROJECT_SUCCESS:
      return action.project;
    case types.RESET_PROJECT_SUCCESS:
      return {};
    default:
      return state;
  }
};

export const savingProject = (state = initialState.savingProject, action) => {
  switch (action.type) {
    case types.SAVING_PROJECT:
      return action.savingProject;

    default:
      return state;
  }
};

export const projectToDelete = (
  state = initialState.projectToDelete,
  action
) => {
  switch (action.type) {
    case types.REQUEST_PROJECT_ID:
      return action.projectToDelete;

    default:
      return state;
  }
};

export const projectTaskToDelete = (
  state = initialState.projectTaskToDelete,
  action
) => {
  switch (action.type) {
    case types.REQUEST_PROJECT_TASK_ID:
      return action.projectTaskToDelete;

    default:
      return state;
  }
};

export const projectNoteToDelete = (
  state = initialState.projectNoteToDelete,
  action
) => {
  switch (action.type) {
    case types.REQUEST_PROJECT_NOTE_ID:
      return action.projectNoteToDelete;

    default:
      return state;
  }
};

export const projectAttachmentToDelete = (
  state = initialState.projectAttachmentToDelete,
  action
) => {
  switch (action.type) {
    case types.REQUEST_PROJECT_ATTACHMENT_ID:
      return action.projectAttachmentToDelete;

    default:
      return state;
  }
};

export const projectNotificationToDelete = (
  state = initialState.projectNotificationToDelete,
  action
) => {
  switch (action.type) {
    case types.REQUEST_PROJECT_NOTIFICATION_ID:
      return action.projectNotificationToDelete;

    default:
      return state;
  }
};

export const paginatedProjects = (
  state = initialState.paginatedProjects,
  action
) => {
  switch (action.type) {
    case types.GET_PROJECTS_SUCCESS:
      return action.projects;
    default:
      return state;
  }
};

export const withSupportResourcesProjects = (
  state = initialState.withSupportResourcesProjects,
  action
) => {
  switch (action.type) {
    case types.LOAD_PROJECTS_WITH_SUPPORT_RESOURCES_SUCCESS:
      return action.data;
    default:
      return state;
  }
};
